import React from 'react';
import type { ViewProps } from 'react-native';
import { StyleSheet, View } from 'react-native';
import { BodyText, Card, Image, LabelText } from '@sweetgreen/garnish';

import { useDynamicStyles } from './FeaturedChannels.styles';

export const FeaturedChannel = (props: React.ComponentProps<typeof Card>) => {
  const { containerStyle } = useDynamicStyles();

  return <Card style={containerStyle} {...props} />;
};

const Illustration = (props: React.ComponentProps<typeof Image>) => {
  const { imageStyle } = useDynamicStyles();

  return (
    <Image style={imageStyle} accessibilityIgnoresInvertColors {...props} />
  );
};

const TextContainer = ({ children }: ViewProps) => {
  return <View style={styles.textContainer}>{children}</View>;
};

const Title = (props: React.ComponentProps<typeof BodyText>) => {
  const { titleStyle } = useDynamicStyles();

  return (
    <BodyText
      size={2}
      numberOfLines={2}
      ellipsizeMode="tail"
      style={titleStyle}
    >
      {props.children}
    </BodyText>
  );
};

const Label = (props: React.ComponentProps<typeof LabelText>) => {
  const { labelStyle } = useDynamicStyles();

  return (
    <LabelText size={1} style={labelStyle}>
      {props.children}
    </LabelText>
  );
};

const Name = (props: React.ComponentProps<typeof BodyText>) => {
  const { nameStyle } = useDynamicStyles();

  return (
    <BodyText
      size={2}
      style={nameStyle}
      numberOfLines={2}
      ellipsizeMode="tail"
      bold
    >
      {props.children}
    </BodyText>
  );
};

const ButtonWrapper = (props: React.ComponentProps<typeof View>) => {
  const { buttonStyle } = useDynamicStyles();

  return <View style={buttonStyle}>{props.children}</View>;
};

const styles = StyleSheet.create({
  textContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
  },
});

/* eslint-disable functional/immutable-data */
FeaturedChannel.Illustration = Illustration;
FeaturedChannel.TextContainer = TextContainer;
FeaturedChannel.Title = Title;
FeaturedChannel.Label = Label;
FeaturedChannel.Name = Name;
FeaturedChannel.ButtonWrapper = ButtonWrapper;
